import { render } from "./App.vue?vue&type=template&id=43d7bc1b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=43d7bc1b&lang=css"

import exportComponent from "/Users/ayion/dev/dork/fmoj-vacms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__